import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { environment } from 'src/environments/environment';

export interface Product {
  id: number;
  name: string;
  default_code: string;
  list_price: number;
}

export type LabelType = 'estanteria' | 'a4' | 'a5' | 'a6' | 'pequenas';

@Injectable({
  providedIn: 'root',
})
export class LabelsService {
  constructor(private functions: Functions) {}

  async generateLabels(type: LabelType, products: Product[]) {
    const callable = httpsCallable<
      { type: LabelType; products: Product[]; isProd: boolean },
      {
        filename: string;
        contentType: string;
        base64: string;
      }
    >(this.functions, 'generate_labels');

    const res = await callable({
      isProd: environment.production,
      products,
      type,
    });

    // Decodifica base64 a un ArrayBuffer
    const byteCharacters = atob(res.data.base64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);

    // Crea un Blob con el contenido del PDF
    const blob = new Blob([byteArray], { type: res.data.contentType });

    // Crea una URL para ese Blob y ábrelo en una nueva pestaña
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }
}
